import Vue from 'vue';
import App from './App.vue';
import router from './router';
import Axios, { AxiosStatic } from 'axios';
import store from '@/store/store';

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

import { SnotifyService } from 'vue-snotify/SnotifyService';
import Snotify from 'vue-snotify';

import 'vue-snotify/styles/material.css';
import Moment from 'vue-moment';

import VueAnalytics from 'vue-analytics';

import Datepicker from 'vuejs-datepicker';
Vue.component('Datepicker', Datepicker);

// @ts-expect-error vue-country-region-select does not provide types
import vueCountryRegionSelect from 'vue-country-region-select';
Vue.use(vueCountryRegionSelect);

Vue.use(Moment);

import vSelect from 'vue-select';
Vue.component('VSelect', vSelect);

import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);

// Register all custom validators globally
registerValidators();

import VueTelInput from 'vue-tel-input';
let globalOptions = {
};
Vue.use(VueTelInput, [globalOptions]);

import UserRepository from './utils/API/UserRepository';
import { SET_USER_DETAILS } from './store/MutationTypes';
import {registerValidators} from "@/utils/Validators";

Vue.use(VueAnalytics, {
  id: 'G-ZDX2F0RV4B'
});

Vue.use(Snotify, {
  toast: {
    timeout: 5000,
    showProgressBar: false,
    position: 'leftTop',
    closeOnClick: true,
  },
});

Vue.prototype.$eventBus = new Vue();
Vue.prototype.$http = Axios;

declare module 'vue/types/vue' {
  interface Vue {
    $eventBus: Vue;
    $http: AxiosStatic;
    $snotify: SnotifyService;
    $moment: any;
  }
}


Vue.config.productionTip = false;

UserRepository.fetchUserInfo()
  .then((response) => {

    store.commit(SET_USER_DETAILS, { userDetails: response.data.result, logged: true });

    new Vue({
      router,
      store,
      render: (h) => h(App)
    }).$mount('#app');

  })
  .catch(() => {
    new Vue({
      router,
      store,
      render: (h) => h(App)
    }).$mount('#app');
  });

// document.getElementById("contact-email").style.pointerEvents = "none";
// var email = document.querySelector('input[email="contact.email"]');
// email.addEventListener("focus", (event) => {
//   event.target.style.pointerEvents = "none";
// });
